module.exports = __webpack_public_path__ + "img/close.ee35d790.png";